import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * Legacy `/dashboard` → `/voxlane`. The portal used to host a single
 * product at `/dashboard/*`; routes are now namespaced per module so the
 * URL says which utility you're in. This and the `$` splat beside it keep
 * existing bookmarks working.
 */
export const Route = createFileRoute("/dashboard/")({
  beforeLoad: () => {
    throw redirect({ to: "/voxlane", replace: true })
  },
})
